import { api } from '../utils/apiClient';

export const campaignService = {
  // Returns { data, meta } — meta.total is the count for the whole filtered
  // set (month/year + status), not just this page; meta.statusCounts backs
  // the listing page's filter-tab badges for that same window.
  async getAll(params) {
    return api.getWithMeta('/campaigns', params);
  },

  async getById(id) {
    return api.get('/campaigns/' + id);
  },

  async create(campaign) {
    return api.post('/campaigns', campaign);
  },

  async update(id, patch) {
    return api.put('/campaigns/' + id, patch);
  },

  async remove(id) {
    return api.del('/campaigns/' + id);
  },

  async launch(id) {
    return api.post('/campaigns/' + id + '/launch');
  },

  async pause(id) {
    return api.post('/campaigns/' + id + '/pause');
  },

  async resume(id) {
    return api.post('/campaigns/' + id + '/resume');
  },

  async cancel(id) {
    return api.post('/campaigns/' + id + '/cancel');
  },

  async duplicate(id) {
    return api.post('/campaigns/' + id + '/duplicate');
  },

  async analytics(id) {
    return api.get('/campaigns/' + id + '/analytics');
  },

  // Real historical delivery/click/conversion rates for a channel, aggregated
  // across every campaign ever sent on it (plus a funnel breakdown and daily
  // volume for the last `days` days). has_data is false when nothing's been
  // sent on that channel yet.
  async channelStats(channel, days) {
    return api.get('/campaigns/channel-stats', { channel, ...(days ? { days } : {}) });
  },

  // Returns { uploadUrl, publicUrl } — caller PUTs the file directly to
  // uploadUrl (presigned S3 URL, this backend never sees the file bytes),
  // then uses publicUrl as the campaign's imageUrl. See ImageUpload.jsx.
  async getImageUploadUrl(fileName, contentType) {
    return api.post('/campaigns/image-upload-url', { file_name: fileName, content_type: contentType });
  },

  // Fires one real message to a single target through the exact provider a
  // real campaign send would use — works against an unsaved draft, since
  // it's not tied to any campaign_id. See TestSendModal.jsx.
  async testSend({ channel, template, target }) {
    return api.post('/campaigns/test-send', { channel, template, target });
  },

  // Real approved WhatsApp template content (header/body/footer/buttons) for
  // the wizard's live preview — { found: false } is a normal response (unknown
  // name, not yet approved), not an error. See WhatsappFields.jsx.
  async getWhatsappTemplate({ templateName, language }) {
    return api.get('/campaigns/templates/whatsapp', { templateName, language });
  },

  // Real approved RCS template content (title/description/image/buttons) for
  // the wizard's live preview. See RcsFields.jsx.
  async getRcsTemplate({ templateId }) {
    return api.get('/campaigns/templates/rcs', { templateId });
  },

  // Every approved WhatsApp template — backs the wizard's template dropdown.
  // Returns { templates: [{name, language, category}], reason? }.
  async listWhatsappTemplates() {
    return api.get('/campaigns/templates/whatsapp/list');
  },

  // Every approved RCS template — backs the wizard's template dropdown.
  // Returns { templates: [{id, functionName, title}], reason? }.
  async listRcsTemplates() {
    return api.get('/campaigns/templates/rcs/list');
  },
};
